import { Button, CircularProgress } from '@mui/material';
import Spin from 'components/spin';
import { saveAs } from 'file-saver';
import { useState } from 'react';
import { CiExport } from 'react-icons/ci';
import { PiExport } from 'react-icons/pi';
import { toast } from 'react-toastify';
import styles from '../styles.module.scss';

type Prop = {
  exportFn: () => Promise<any>;
  fileName: string;
  disabled?: boolean;
  iconOnly?: boolean;
};

const ExportToExcelFile = ({ exportFn, fileName, disabled, iconOnly }: Prop) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (disabled || loading) return;
    setLoading(true);
    try {
      const response = await exportFn();
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      toast.error('Ошибка при экспорте');
    } finally {
      setLoading(false);
    }
  };

  if (iconOnly) {
    return (
      <Button
        disabled={disabled || loading}
        onClick={handleExport}
        id='export'
        aria-label='export'
        sx={{
          padding: 0,
          background: 'transparent !important',
          minWidth: '20px',
          display: disabled ? 'none' : 'flex',
        }}>
        {loading ? <Spin /> : <CiExport size={35} color={disabled ? '#BEBFC1' : '#005AA9'} />}
      </Button>
    );
  }

  return (
    <Button
      disabled={disabled || loading}
      onClick={handleExport}
      className={styles.exportButton}
      endIcon={
        loading ? (
          <CircularProgress size={18} color='inherit' />
        ) : (
          <PiExport className={styles.exportIcon} />
        )
      }>
      {loading ? 'Загрузка...' : 'Экспорт'}
    </Button>
  );
};

export default ExportToExcelFile;
